import Nullstack from 'nullstack';
export default function IconPlaceholder({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-placeholder",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 20.415a8 8 0 1 0 3 -15.415h-3"
  }), "   ", Nullstack.element("path", {
    d: "M13 8l-3 -3l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M7 17l4 -4l-4 -4l-4 4z"
  }), " ");
}